import { render } from "./MobileAppView.vue?vue&type=template&id=1b7a01e4"
import script from "./MobileAppView.vue?vue&type=script&lang=js"
export * from "./MobileAppView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__